<template>
    <div class="container-fluid bg-secondary bukola text-white mt-5 py-5 px-sm-3 px-md-5">
        <div class="row pt-5">
            <div class="col-lg-4 col-md-12 mb-5">
                <h1 class="mb-3 display-5 text-capitalize font-italic text-black"><span class="text-primary color-bar">Safety</span>First</h1>
                <p class="m-0">Ipsum amet sed vero et lorem stet eos ut, labore sed sed stet sea est ipsum ut. Volup amet ea sanct ipsum, dolore vero lorem no duo eirmod. Eirmod amet ipsum no ipsum lorem clita ut. Ut sed sit lorem ea lorem sed, amet stet sit sea ea diam tempor kasd kasd. Diam nonumy etsit tempor ut sed diam sed et ea</p>
            </div>
            <div class="col-lg-8 col-md-12">
                <div class="row">
                    <div class="col-md-4 mb-5">
                        <h5 class="text-primary color-bar mb-4">Quick Links</h5>
                        <div class="d-flex flex-column justify-content-start">
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>Home</a>
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>About Us</a>
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>Our Services</a>
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>Our Team</a>
                            <a class="text-white bukola" href="#"><i class="fa fa-angle-right mr-2"></i>Contact Us</a>
                        </div>
                    </div>
                    <div class="col-md-4 mb-5">
                        <h5 class="text-primary color-bar mb-4">Popular Links</h5>
                        <div class="d-flex flex-column justify-content-start">
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>Home</a>
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>About Us</a>
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>Our Services</a>
                            <a class="text-white bukola mb-2" href="#"><i class="fa fa-angle-right mr-2"></i>Our Team</a>
                            <a class="text-white bukola" href="#"><i class="fa fa-angle-right mr-2"></i>Contact Us</a>
                        </div>
                    </div>
                    <div class="col-md-4 mb-5">
                        <h5 class="text-primary color-bar mb-4">Get In Touch</h5>
                        <p class="small">
                            56, Owulade estate Irawo<br />
                            Ikorodu road,<br />
                            Lagos
                        </p>
                        <b-icon icon="telephone"> +2348182360900</b-icon>
                        <p class="small mb-1">📞 +2348182360900</p>
                        <p class="small mb-1">📧 info@closewatchng.com</p>
                        <div>
                            <b-link href="https://twitter.com" class="text-light mr-3">
                              <b-icon icon="facebook" aria-hidden="true"></b-icon>
                            </b-link>
                            <b-link href="https://linkedin.com" class="text-light mr-3">
                               <b-icon icon="twitter" aria-hidden="true"></b-icon>
                            </b-link>
                            <b-link href="https://github.com" class="text-light">
                               <b-icon icon="instagram" aria-hidden="true"></b-icon>
                            </b-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-md-6 text-center text-md-left mb-3 mb-md-0">
                <p class="m-0 text-black">
                    &copy; <a class="text-black font-weight-bold color-bar" href="#">Your Site Name</a>. All Rights Reserved. 
					
					<!--/*** This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. ***/-->
					Designed by <a class="text-black font-weight-bold color-bar">Adeyeba</a>
                </p>
            </div>
            <div class="col-md-6 text-center text-md-right">
                <ul class="nav d-inline-flex ">
                    <li class="nav-item">
                        <a class="nav-link text-black py-0 color-bar" href="#">Privacy</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-black py-0 color-bar" href="#">Terms</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-black py-0 color-bar" href="#">FAQs</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link text-black py-0 color-bar" href="#">Help</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
   export default {
  name: "TestPage",
};
</script>

<style scoped>
.bukola {
    background-color: #F8F9FA !important;
    color: #000 !important;
}
.color-bar{
    color: #990000 !important;
}
</style>